<button
  cuiButton
  size="small"
  variant="plain"
  surface="muted"
  type="button"
  [cuiDropdownTriggerFor]="expertMenu"
  aria-label="Choose expert">
  <span class="material-symbols-outlined" aria-hidden="true">robot_2</span>
  <span class="expert-picker-name">{{ selectedExpert()?.name || 'Select expert' }}</span>
</button>
<cui-dropdown #expertMenu>
  @for (expert of experts(); track expert.id) {
    <button
      cuiButton
      cdkMenuItem
      class="cui-dropdown__item expert-option"
      variant="plain"
      [active]="selectedExpert()?.id === expert.id"
      type="button"
      (click)="selectExpert.emit(expert.id); expertMenu.close()">
      <span class="expert-option-text">
        <strong>{{ expert.name }}</strong>
        <span>{{ expert.description || 'No description' }}</span>
      </span>
    </button>
  } @empty {
    <p class="expert-option-empty">No experts available.</p>
  }
</cui-dropdown>
